export default __webpack_public_path__ + "static/mongodb-5629120bd282912eaaab10ad3e2d8347.png";